Application.Signature.Wallpaper = {
    ui: {
        container: '.step-wallpaper_type',
        form: '.step-wallpaper_type form',
        options: '.step-wallpaper_type .el-selectable-box input',
        submit: '.step-wallpaper_type .step-preview__submit'
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        // events
        $(this.ui.options).on('change', function (e) {
            self.update();
        });
        $(this.ui.form).on('submit', function (e) {
            if (!self.isOptionChecked()){
                e.preventDefault();
            }
        });

        // init
        this.update();

    },
    update: function(){

        $(this.ui.submit).toggleClass('btn_disabled', !$(this.ui.options).filter(':checked').length);

    }
};